export function getTeacherUrl(url) {
    return '/teacher/' + url.replace(/^\/+/, '');
}

export function getStudentUrl(url) {
    return '/student/' + url.replace(/^\/+/, '');
}

export function getSinglePlayerUrl(url) {
    return '/single-player/' + url.replace(/^\/+/, '');
}